import React from "react";
import DefaultQuestionBody from "./DefaultQuestionBody";

const PersonFinderComponent = () => <DefaultQuestionBody />;

PersonFinderComponent.information = {
	type: "select",
	cayuseType: "person-finder",
	name: "Person Finder",
};

PersonFinderComponent.extraSettings = {
	tagsEnabled: false,
	preselectAll: false,
	clientSideFiltering:false,
	enableAutocomplete: true,
	autocompleteMinLength: 1,
	dataSource: "Rest",
	queryUrl: "{{endpoints.cayuse}}/person?search={{$searchText}}",
	lookupUrl: "{{endpoints.cayuse}}/person/{{$id}}",
	linkTargetView: "browse",
	formatItem: "{{$item.name}}",
	storage: "Id",
	identity: "id",
	linkTarget: "_blank",
	multi: false
};

PersonFinderComponent.customOptions = [
	{
		label: "User can select multiple people",
		type: "multi"
	}
];

export default PersonFinderComponent;
